import queryString from 'query-string';

/**
 *
 * @param {String} param - the key of the required parmeter value
 * @param {String} urlPath - optional, specify url to get the parameters from (will get the url by itself if left empty)
 */
export default function getUrlParam(param, urlPath = null) {
  if (!urlPath) {
    urlPath = window.location.search;
  }

  let query = queryString.parse(urlPath);

  if (query && query[param]) {
    return query[param];
  }

  return null;
}
